import React, { useEffect, useState } from 'react'
import {
    Button,
    Row,
    Col,
    Card,
    Avatar,
    message,
    Modal,
    Space,
    Upload,
    Divider,
    Switch,
} from 'antd';
import {
    IdcardOutlined,
    CheckCircleOutlined,
    StopOutlined,
    IssuesCloseOutlined,
    BankOutlined,
    PlusOutlined,
    TeamOutlined,
} from '@ant-design/icons';
import { user, sys } from '../../../../service';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import ImgCrop from 'antd-img-crop';
import MapView from '../../../../components/map'

import './index.scss'

export default function InfoView() {
    const navigate = useNavigate()
        , [basicInfo, setBasicInfo] = useState({})
        , [showMask, setShowMask] = useState(false)
        , [openAvatar, setOpenAvatar] = useState(false)
        , { serverUrl } = useSelector(state => state.siteInfo)
        , { companyName } = useSelector(state => state.basic)
        , [avatarList, setAvatarList] = useState([])        // 上传的图片列表
        , mapRef = React.useRef(null)
        , [marker, setMarker] = useState(false)
        , [coords, setCoords] = useState([])

    useEffect(() => {
        async function fetchData() {
            const { data } = await user.getBasicInfo()
            setBasicInfo(data)
            setCoords(data.position || [])
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (coords.length) {
            async function fetchData() {
                drawMarker()
            }
            fetchData()
        }
    }, [coords])

    const drawMarker = (isClear = true) => {
        mapRef.current.drawStrips({
            data: basicInfo.position ? [{ ...basicInfo, content: basicInfo.name, latlng: coords, }] : [],
            mode: 'multiple',
            type: "Marker",
            pmIgnore: false,
            isFitBounds: true,
            isClear,
            onEdit: ({ record, layer, latlng }) => {
                setCoords(latlng)
            },

            onRemove: (value) => {
                console.log('remove', value);
                return
            }
        })
    }

    const handleAvatarOk = () => {
        setOpenAvatar(false)
    }

    const handleAvatarCancel = () => {
        setOpenAvatar(false)
        setAvatarList([])
    }

    const setposition = async () => {
        try {
            await user.apiAuth.position(coords)
            message.success('保存成功！')
        } catch (error) {
            message.error('保存失败！')
        }
    }

    const onPayChange = async (checked) => {
        try {
            await user.apiAuth.paySwitch(+checked)
            message.success('设置成功！')
        } catch (error) {
            message.error('设置失败！')
        }
    }

    return (
        <div>
            <Card
                className='user-info-container'
            >
                <Row>
                    <Col span={8}>
                        <Card.Meta
                            avatar={
                                <div
                                    onMouseEnter={() => setShowMask(true)}
                                    onMouseLeave={() => setShowMask(false)}
                                >
                                    <Avatar
                                        className='user-avatar'
                                        src={serverUrl + basicInfo.imageUrl}
                                        style={{ width: '80px', height: '80px' }}
                                    />

                                    <div
                                        style={{ display: showMask ? 'block' : 'none' }}
                                        className='avatar-mask'
                                        onClick={() => setOpenAvatar(true)}
                                    >修改头像</div>
                                </div>
                            }
                            title={basicInfo.name}
                            description={<div>
                                <div>{companyName || ''}</div>
                                <div>{basicInfo.phone}</div>
                            </div>}
                        />
                    </Col>
                </Row>


            </Card>

            <Card
                style={{ border: 'none' }}
            >
                <div>
                    是否支持实物支付：
                    <Switch
                        checkedChildren="是"
                        unCheckedChildren="否"
                        onChange={(checked) => onPayChange(checked)}
                        checked={!!basicInfo.matterPay}
                    />

                </div>
                <Divider />

                <Row style={{ marginTop: 35 }}>
                    <Col span={12}>
                        <Card.Meta
                            avatar={
                                <Avatar icon={<IdcardOutlined style={{ fontSize: '30px', marginTop: '12px' }} />}
                                    style={{ width: '60px', height: '60px', background: '#44AFAD' }}
                                />
                            }
                            title={<>
                                <span className='m-r-sm'>个人认证</span>
                                {
                                    basicInfo.identityState === 0 ? (
                                        <Button
                                            type='primary'
                                            size='small'
                                            onClick={() => navigate('/usercenter/info/userauth')}
                                        >去认证</Button>
                                    ) : basicInfo.identityState === 1 ? (
                                        <span style={{ color: '#2CB861' }}><CheckCircleOutlined /> 已认证</span>
                                    ) : basicInfo.identityState === 2 ? (<span style={{ color: '#FAAD14' }}><IssuesCloseOutlined /> 待审核</span>)
                                        : (<Button
                                            type='primary'
                                            danger
                                            size='small'
                                            onClick={() => navigate('/usercenter/info/userauth')}
                                        >未通过</Button>)

                                }
                            </>}
                            description={'需提供个人身份证，可发需求/下单服务'}
                        />
                    </Col>
                    <Col span={12}>
                        <Card.Meta
                            avatar={
                                <Avatar icon={<BankOutlined style={{ fontSize: '30px', marginTop: '12px' }} />}
                                    style={{ width: '60px', height: '60px', background: '#44AFAD' }}
                                />
                            }
                            title={<>
                                <span className='m-r-sm'>企业认证</span>
                                {
                                    basicInfo.iosState === 0 ? (
                                        <Button
                                            type='primary'
                                            size='small'
                                            onClick={() => navigate('/usercenter/info/enterauth')}
                                        >去认证</Button>
                                    ) : basicInfo.iosState === 1 ? (
                                        <span style={{ color: '#2CB861' }}><CheckCircleOutlined /> 已认证</span>
                                    ) : basicInfo.iosState === 2 ? (<span style={{ color: '#FAAD14' }}><IssuesCloseOutlined /> 待审核</span>)
                                        : (<Button
                                            type='primary'
                                            danger
                                            size='small'
                                            onClick={() => navigate('/usercenter/info/enterauth')}
                                        >未通过</Button>)

                                }
                            </>}
                            description={'需提供营业执照图片，可享受发布服务/需求等功能'}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: 35 }}>
                    <Col span={12}>
                        <Card.Meta
                            avatar={
                                <Avatar icon={<TeamOutlined style={{ fontSize: '30px', marginTop: '12px' }} />}
                                    style={{ width: '60px', height: '60px', background: '#44AFAD' }}
                                />
                            }
                            title={<>
                                <span className='m-r-sm'>组织认证</span>
                                {
                                    basicInfo.orgState === 0 ? (
                                        <Button
                                            type='primary'
                                            size='small'
                                            onClick={() => navigate('/usercenter/info/groupauth')}
                                        >去认证</Button>
                                    ) : basicInfo.orgState === 1 ? (
                                        <span style={{ color: '#2CB861' }}><CheckCircleOutlined /> 已认证</span>
                                    ) : basicInfo.orgState === 2 ? (<span style={{ color: '#FAAD14' }}><IssuesCloseOutlined /> 待审核</span>)
                                        : (<Button
                                            type='primary'
                                            danger
                                            size='small'
                                            onClick={() => navigate('/usercenter/info/groupauth')}
                                        >未通过</Button>)

                                }
                            </>}
                            description={'需提供带公章的证明材料，可享受发布服务/需求等功能'}
                        />
                    </Col>
                </Row>
            </Card>


            <MapView
                title={'设置位置'}
                ref={mapRef}
                id='devs-map'
                height='500px'
                isLocate={true}
                extra={
                    <Space>
                        <Button
                            disabled={coords.length}
                            onClick={() => {
                                mapRef.current.createDraw({
                                    type: 'Marker',
                                    onCreate: ({ layer }) => {
                                        layer.bindTooltip(basicInfo.name, {
                                            direction: 'top',
                                            permanent: true,
                                            offset: [0, -32]
                                        })
                                    },
                                    onEdit: ({ layer, latlng }) => {
                                        setCoords(latlng)
                                    },
                                    onRemove: () => {
                                        setCoords([])
                                    }
                                })
                            }}
                        >
                            设定位置
                        </Button>

                        <Button
                            type="primary"
                            disabled={coords.length === 0}
                            onClick={setposition}
                        >保存</Button>
                    </Space>
                }
            >
                <p style={{ margin: '5px' }}>当前坐标： {coords.join(', ')}</p>
            </MapView>

            <Modal
                title='修改头像'
                open={openAvatar}
                onCancel={() => setOpenAvatar(false)}
                footer={[
                    <div className='flex center'>
                        <Button
                            key="back"
                            onClick={() => setOpenAvatar(false)}
                        >
                            取消
                        </Button>
                        <Button
                            type='primary'
                            key="back"
                            onClick={() => handleAvatarOk()}
                        >
                            保存
                        </Button>
                    </div>
                ]}
            >
                <div style={{ width: '240px', margin: '60px auto' }}>
                    <ImgCrop rotationSlider >
                        <Upload
                            beforeUpload={async file => {
                                const isImage = file.type.startsWith('image/');
                                if (!isImage) {
                                    message.error('只能上传图片文件');
                                    return false;
                                }

                                const { data: { path } } = await sys.uploadFile(file)
                                setAvatarList([{ ...file, url: serverUrl + path, path }])
                                return false
                            }}
                            listType="picture-card"
                            maxCount={1}
                            name="file"
                            fileList={avatarList}
                            onRemove={() => setAvatarList([])}
                        >
                            <div>
                                <PlusOutlined style={{ fontSize: 40, color: '#ccc' }} />
                            </div>
                        </Upload>
                    </ImgCrop>
                </div>
            </Modal>
        </div >
    )
}
